<template>
    <main>
        <dep-grade-report-wrapper></dep-grade-report-wrapper>
    </main>
</template>

<script>
import DepGradeReportWrapper from './DepGradeReportWrapper';

export default {
    components : {DepGradeReportWrapper}
}
</script>
